<script>
  import { ButtonPrimary } from '@qlean/ui-kit-web-svelte'

  export let text
  export let href
</script>

<ButtonPrimary width={ButtonPrimary.WIDTHS.MEDIUM} rounded isLink {href} class={$$props.class}>{text}</ButtonPrimary>
